export default __webpack_public_path__ + "static/media/visa-card.f5aa4373.svg";